import { useEventDebuggerTableContext } from 'app/event-monitoring/event-debugger/event-debugger-table/EventDebuggerTableContext';
import { VALUELESS_OPERATORS } from 'app/event-monitoring/event-debugger/event-debugger-table/EventDebuggerTableContext/PAYLOAD_CONDITION_OPERATORS';

import usePayloadConditions from './usePayloadConditions';

export default function usePayloadConditionRowProps(condition) {
  const { payloadPaths } = useEventDebuggerTableContext();
  const { updateCondition, removeCondition } = usePayloadConditions();

  const onPathChange = (event, path) => updateCondition({ ...condition, path: path ?? '' });

  // Clear the value when switching to a valueless operator so the condition never carries a value
  // that won't be used.
  const onOperatorChange = ({ target }) => {
    const operator = target.value;
    const value = VALUELESS_OPERATORS.includes(operator) ? '' : condition.value;
    updateCondition({ ...condition, operator, value });
  };

  const onValueChange = ({ target }) => updateCondition({ ...condition, value: target.value });

  return {
    payloadPaths,
    valueDisabled: VALUELESS_OPERATORS.includes(condition.operator),
    onPathChange,
    onOperatorChange,
    onValueChange,
    onRemove: () => removeCondition(condition.id),
  };
}
